module.exports = "/images/icon-feather-edit.svg?34eb729c037d83d41a25f545f54a7f04";